import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Icon,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { RiMenuLine } from "@remixicon/react";
import { useEffect } from "react";
import useScreenWidth from "../lib/useScreenWidth";
import { useGetUserLoginStore } from "../store/useGetUserLoginStore";
import { DrawerNoAuth } from "./drawer/DrawerNoAuth";
import { SwitchAccountDrawer } from "./drawer/SwitchAccountDrawer";
import { MenuDashboardDrawer } from "./menu/MenuDashboardDrawer";
import { MenuNavDrawer } from "./menu/MenuNavDrawer";

interface NavigationDrawerProps {}

const NavigationDrawer = ({ ...rest }: NavigationDrawerProps) => {
  const { isOpen: isNavDrawerOpen, onToggle: onNavDrawerToggle } =
    useDisclosure();
  const sw = useScreenWidth();
  const { currentActiveUser, getCurrentActiveUser } = useGetUserLoginStore();

  useEffect(() => {
    getCurrentActiveUser();
  }, [getCurrentActiveUser]);

  return (
    <>
      <IconButton
        display={{ base: "block", lg: "none" }}
        onClick={onNavDrawerToggle}
        icon={<Icon as={RiMenuLine} fontSize={"2xl"} />}
        variant={"ghost"}
        size={"md"}
        aria-label={"Toggle Navigation"}
        {...rest}
      />

      <Drawer
        isOpen={isNavDrawerOpen}
        placement="right"
        onClose={onNavDrawerToggle}
        size={"md"}
      >
        {sw > 480 && <DrawerOverlay />}

        <DrawerContent>
          {!currentActiveUser && <DrawerCloseButton />}

          <DrawerBody>
            {isNavDrawerOpen &&
              (currentActiveUser ? (
                <>
                  <SwitchAccountDrawer zIndex={1} />

                  <MenuDashboardDrawer zIndex={0} />

                  <MenuNavDrawer onClose={onNavDrawerToggle} />
                </>
              ) : (
                <DrawerNoAuth onClose={onNavDrawerToggle} />
              ))}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default NavigationDrawer;
